/* eslint no-console:0 */
import Cookies from "js-cookie";

function socialShareForm() {
    if (!Cookies.get("socialShare")) {
        return;
    }

    const shareForm = document.getElementById("lfSocialShare");
    const roleOption = shareForm.querySelector("select");
    const shareButton = shareForm.querySelector("button");

    const setCookie = (name, value) => {
        const oneYearFromNow = new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000);
        Cookies.set(name, value, { expires: oneYearFromNow });
    };

    shareForm.addEventListener("submit", (e) => {
        e.preventDefault();

        const formFields = document.querySelectorAll("#jobSearch input, #jobSearch select");
        const inputs = formFields ? Array.from(formFields) : []; // spread into an array only if form is not null

        // Strip current URL of all query parameters
        const currentURLNoParams = `${window.location.origin}${window.location.pathname}`;
        const shareURL = new URL(currentURLNoParams);

        // Append any of the search params to the URL (if exists)
        inputs
            .filter(input => input.value !== "")
            .forEach(input => shareURL.searchParams.append(input.name, input.value));

        // Set the cookie to the selected role and append to copy link
        setCookie("socialShare", roleOption.value);
        shareURL.searchParams.append("r", roleOption.value);

        navigator.clipboard.writeText(shareURL.href)
            .then(() => {
                // Update the button text to indicate that copy happened
                shareButton.innerText = "Copied!";

                // Revert the button text after a short delay
                setTimeout(() => {
                    shareButton.innerText = "Share";
                }, 2000);
            })
            .catch(err => {
                console.error("Failed to copy URL: ", err);
            });
    });
}

export default socialShareForm();
